/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findAll13 } from '../fn/app-reason/find-all-13';
import { FindAll13$Params } from '../fn/app-reason/find-all-13';
import { Reason } from '../models/reason';

@Injectable({ providedIn: 'root' })
export class AppReasonService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll13()` */
  static readonly FindAll13Path = '/api/values/app-reasons';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll13()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll13$Response(params?: FindAll13$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Reason>>> {
    return findAll13(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll13$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll13(params?: FindAll13$Params, context?: HttpContext): Observable<Array<Reason>> {
    return this.findAll13$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Reason>>): Array<Reason> => r.body)
    );
  }

}
